import * as Headless from "@headlessui/react";
import { forwardRef } from "react";

import { Link } from "@/components/clickable";
import { cx } from "@/utils";
import { colors, themes } from "./constants";
import Content from "./content";

const Button = forwardRef(function Button(
  { color, isLoading, outline, plain, className, children, ...props },
  ref,
) {
  let classes = cx(
    themes.base,
    outline
      ? themes.outline
      : plain
        ? themes.plain
        : cx(themes.solid, colors[color ?? "dark/zinc"]),
    className,
  );

  props.disabled = props.disabled || isLoading;

  return "href" in props || "to" in props ? (
    <Link {...props} className={classes} ref={ref}>
      <Content isLoading={isLoading}>{children}</Content>
    </Link>
  ) : (
    <Headless.Button {...props} className={classes} ref={ref}>
      <Content isLoading={isLoading}>{children}</Content>
    </Headless.Button>
  );
});

export default Button;
